"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSuchUpload = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "NoSuchUpload"
};
//# sourceMappingURL=NoSuchUpload.js.map